export const WA = {
  lima: "#C9DF00",
  limaFuerte: "#AFC400",
  limaTint: "#F6FAD9",
  limaTintFuerte: "#ECF3B5",

  turquesa: "#00BFD6",
  naranja: "#FF6A0D",

  bg: "#F4F6F8",
  surface: "#FFFFFF",
  border: "#EBEDF0",
  textPrimary: "#1F2A30",
  textSecondary: "#6B7A82",

  bubbleOut: "#C9DF00",
  bubbleOutText: "#1F2A30",
  bubbleIn: "#FFFFFF",
};

export default WA;
